function removeElement(elment) {
  elment.parentNode.removeChild(elment)
}

function createBtn(className, type = null) {
  let btn = document.createElement('button')
  btn.setAttribute('type', 'button')

  if (type) {
    btn.setAttribute('aria-label', type)
  }

  let classNames = className.split(' ')
  classNames.forEach((name) => btn.classList.add(name))
  return btn
}

export const arrows = (slider) => {
  const arrowWrapper =
    slider?.container?.parentElement.parentElement.querySelector(
      '.js-slider--arrows',
    )

  if (!arrowWrapper || slider.slides.length <= 1) {
    return
  }

  let arrowLeft, arrowRight

  function markup(remove) {
    arrowMarkup(remove)
  }

  function arrowMarkup(remove) {
    if (remove) {
      removeElement(arrowLeft)
      removeElement(arrowRight)
      return
    }

    arrowLeft = createBtn('arrow arrow--left arrow--disabled', 'previous slide')
    arrowLeft.addEventListener('click', () => slider.prev())
    arrowRight = createBtn('arrow arrow--right', 'next slide')
    arrowRight.addEventListener('click', () => slider.next())

    arrowWrapper.appendChild(arrowLeft)
    arrowWrapper.appendChild(arrowRight)
  }

  function updateClasses() {
    let slide = slider.track.details.rel

    slide === 0
      ? arrowLeft.classList.add('arrow--disabled')
      : arrowLeft.classList.remove('arrow--disabled')

    slide === slider.track.details.slides.length - 1
      ? arrowRight.classList.add('arrow--disabled')
      : arrowRight.classList.remove('arrow--disabled')

    if (slider.track.details.maxIdx === slide) {
      arrowLeft.classList.remove('arrow--disabled')
      arrowRight.classList.add('arrow--disabled')
    }
  }

  slider.on('created', () => {
    markup()
    updateClasses()

    const sliderElement = slider.container
    sliderElement.classList.remove('opacity-0')
  })

  slider.on('optionsChanged', () => {
    markup(true)
    markup()
    updateClasses()
  })

  slider.on('slideChanged', () => updateClasses())

  slider.on('destroyed', () => markup(true))
}

export const keyboard = (slider) => {
  if (slider.slides.length <= 1) {
    return
  }

  document.addEventListener('keydown', ({ key }) => {
    if (!key) return

    if (key === 'ArrowLeft') {
      slider.prev()
    }

    if (key === 'ArrowRight') {
      slider.next()
    }
  })
}
